import React, {useState} from 'react';
import useCapitalMessage from '@di-shared/features/capital/useCapitalMessage';
import useWindowFocusTracker from '@di-shared/features/common/useWindowFocusTracker';

export interface CapitalFrameProps {
  vin: string;
  to: string;
  isInitMounted: boolean;
}

function CapitalFrame(props: CapitalFrameProps): JSX.Element {
  const [key, setKey] = useState(0);

  useWindowFocusTracker({
    isInitiallyEnabled: true,
    onFocus: () => setKey((key) => key + 1), // 리포커스 시 iframe 리렌더
  });

  return (
    <Inner
      key={key}
      {...props}
    />
  );
}

function Inner({vin, to, isInitMounted}: CapitalFrameProps) {
  const {iframeRef, isMounted} = useCapitalMessage(vin, to, isInitMounted);

  return (
    <>
      <iframe
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-modals"
        ref={iframeRef}
        src={to}
        frameBorder="0"
        style={{width: '100%', height: '100%', display: isMounted ? 'block' : 'none'}}
      ></iframe>
      {!isMounted && (
        <div style={{padding: 20}}>
          <div
            className="skeleton"
            style={{width: '100%', height: 188, marginBottom: 18}}
          ></div>
          <div
            className="skeleton"
            style={{width: '100%', height: 188}}
          ></div>
        </div>
      )}
    </>
  );
}

export default CapitalFrame;
